import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Router } from 'react-router-dom';
import history from "./history";
import { Provider } from 'react-redux';
import store from './code/redux/store';
// import store2  from './code/js/appStates/dragonTiger/store';
import axios from "axios";
// axios.defaults.baseURL = 'http://10.10.20.58:8899/';
let logskey = sessionStorage.getItem("logskey")

if (logskey ==="logskey") {
  // console.log = () => { };
  // console.error = () => { };
  // console.warn = () => { };
  // console.info = () => { };
}else{
  console.log = () => { };
  console.error = () => { };
  console.warn = () => { };
  console.info = () => { };
}
ReactDOM.render(
  <Router history={history}>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById('root')
);